import { css } from 'aphrodite';
import React from 'react';
import { styleSheet } from '../styles';

interface ISettingRowProps {
	title: string;
	subtitle: string;
	children: React.ReactNode;
	error?: string;
	isSubSetting?: boolean;
}

export const SettingRow: React.FC<ISettingRowProps> = ({ title, subtitle, children, error, isSubSetting }) => {
	return (
		<div className={css(styleSheet.settingRow, isSubSetting && styleSheet.settingRowSubSetting)}>
			<div className={css(styleSheet.settingHeader)}>
				<h6 className={css(styleSheet.settingTitle)}>{title}</h6>
				<div className={css(styleSheet.settingSubtitle)}>{subtitle}</div>
			</div>
			{error && <div className={css(styleSheet.settingError)}>{error}</div>}
			<div className={css(styleSheet.settingControls)}>{children}</div>
		</div>
	);
};
